module.exports = __webpack_public_path__ + "static/img/h2-2.e19d955.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/h2-2.png
// module id = kE6O
// module chunks = 1